import * as yup from 'yup';

export const customTermsValidationMessage =
    'The URL entered is not in the correct formatting, the URL should contain https:// or http:// at the start.';

export const validationSchema = yup.object({
    termAndConditions: yup
        .string()
        .nullable()
        .when('useCustomTerms', {
            is: true,
            then: (schema: yup.StringSchema) => {
                return schema
                    .trim()
                    .matches(/^https?:\/\/.+/i, customTermsValidationMessage)
                    .required('Required');
            },
            otherwise: (schema: yup.StringSchema) => {
                return schema.notRequired().nullable();
            },
        }),
});
